var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDateIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 8H4v1h8zM12 11H4v1h8z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 0h3v2h6V0h3v2h2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2h2zM1 3v2h14V3zm0 11V6h14v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1",
  clipRule: "evenodd"
})));
export default SvgDateIcon;